<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch('account/ensureUserInfo');
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/common/reset.scss';

#app {
  height: 100%;
}
</style>
